import { put, takeLatest, all, call } from "redux-saga/effects";
import {
  setLoading,
  removeLoading,
  getItemFromLocalStorage,
} from "../../utils";
import { get, post, put as putCall } from "../../api";
import {
  GET_MY_BOOKINGS,
  GET_MY_BOOKINGS_SUCCESS,
  BOOK_APPOINTMENT,
  BOOK_APPOINTMENT_SUCCESS,
  FIND_AVAILABLE_SLOTS,
  FIND_AVAILABLE_SLOTS_SUCCESS,
  CANCEL_BOOKINGS,
  SEARCH_USER,
  SEARCH_USER_SUCCESS,
  GET_TOP_SALONS,
  SET_TOP_SALONS,
} from "../constants";
import {
  GET_SALON_MY_BOOKINGS as GET_SALON_MY_BOOKINGS_API,
  BOOK_CANCEL_APPOINTMENT as BOOK_CANCEL_APPOINTMENT_API,
  GET_AVAILABLE_SLOTS as GET_AVAILABLE_SLOTS_API,
  SEARCH_SALON as SEARCH_SALON_API,
  TOP_SALONS as TOP_SALONS_API,
} from "../../api/endpoints";
import { mergeSlotsForSelection } from "../../utils";

function* getMyBookings({ userId }) {
  setLoading();
  if (userId) {
    const baseApi = `${GET_SALON_MY_BOOKINGS_API}${userId}/appointments`;
    const userData = yield call(get, baseApi);
    yield put({ type: GET_MY_BOOKINGS_SUCCESS, data: userData.data });
  }
  removeLoading();
}

function* cancelBookings({ payload: { userId, id } }) {
  setLoading();
  const baseApi = `${BOOK_CANCEL_APPOINTMENT_API}/${id}/cancel`;
  yield call(putCall, {
    endpoint: baseApi,
    params: {},
  });
  yield call(getMyBookings, { userId: userId });
  removeLoading();
}

function* makeAppointment({ payload }) {
  setLoading();
  const baseApi = `${BOOK_CANCEL_APPOINTMENT_API}`;
  const userData = yield call(post, {
    endpoint: baseApi,
    params: payload,
  });
  removeLoading();
  yield put({ type: BOOK_APPOINTMENT_SUCCESS, data: userData.data });
}

function* findAvailableSlots({ payload: { salonId, date, duration } }) {
  setLoading();
  const baseApi = `${GET_AVAILABLE_SLOTS_API}/${salonId}/availability_for_business?date=${date}&duration=${duration}`;
  const slots = yield call(get, baseApi);
  removeLoading();
  const mergedModifiedSlots = mergeSlotsForSelection(slots.data.slots);
  yield put({ type: FIND_AVAILABLE_SLOTS_SUCCESS, data: mergedModifiedSlots });
}

function* searchUser({ payload }) {
  setLoading();
  const salonApi = `${SEARCH_SALON_API}${payload}`;
  const salonResult = yield call(get, salonApi);
  removeLoading();

  yield put({
    type: SEARCH_USER_SUCCESS,
    data: {
      salons: salonResult.data.salons,
    },
  });
}

function* getTopSalons({ payload }) {
  setLoading();
  const location = getItemFromLocalStorage("location");
  const { gender } = payload;
  const salonApi = `${TOP_SALONS_API}latitude=${location.latitude}&longitude=${location.longitude}&gender=${gender}`;
  try {
    const { data } = yield call(get, salonApi);
    yield put({
      type: SET_TOP_SALONS,
      data,
    });
  } catch (err) {
    console.log(err);
  }
  removeLoading();
}

function* actionWatcher() {
  yield takeLatest(GET_MY_BOOKINGS, getMyBookings);
  yield takeLatest(BOOK_APPOINTMENT, makeAppointment);
  yield takeLatest(FIND_AVAILABLE_SLOTS, findAvailableSlots);
  yield takeLatest(CANCEL_BOOKINGS, cancelBookings);
  yield takeLatest(SEARCH_USER, searchUser);
  yield takeLatest(GET_TOP_SALONS, getTopSalons);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
